<template>
  <div id="app">
    <loading v-if="loading" />
    <component :is="layout" />
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import PDentalLayout from "@/views/pdental/Layout.vue";
import PridgeLayout from "@/views/pridge/Layout.vue";
export default {
  name: "App",
  components: { Loading },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    document.addEventListener("loader", this.handleLoader);
  },
  beforeDestroy() {
    document.removeEventListener("loader", this.handleLoader);
  },
  watch: {
    $route(val) {
      console.log("🚀 ~ handler ~ val:", val);
      console.log("🚀 ~ handler ~ val:", val.params.CID);
      if (val && val.params && val.params.CID) {
        this.$axios
          .get("website/FetchClinicData", {
            params: {
              Cid: val.params.CID,
            },
          })
          .then((response) => {
            this.$store.dispatch("updateClinicData", response.data);
          });
      } else {
        this.$store.dispatch("resetClinicData");
      }
    },
  },
  computed: {
    layout() {
      return this.$brand.isPridge ? PridgeLayout : PDentalLayout;
    },
    isLoading() {
      return this.$axios.state.isLoading;
    },
  },
  methods: {
    handleLoader(event) {
      this.loading = event.detail.loading;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 20px;
}
</style>
